import { continueToNextSection } from './case_experience_in_rails';
import { railsStudentCaseUnlockContinue } from './case_experience_api';

export function isStudentUnlockContinueFlow() {
  return railsStudentCaseUnlockContinue();
}

export function isContinueButtonName(nameValue) {
  return nameValue?.toLowerCase() === 'continue';
}

export async function runStudentContinueUnlock(opts) {
  if (!railsStudentCaseUnlockContinue()) return null;
  return continueToNextSection({
    ...opts,
    createContinueButtonIfNeeded: false,
  });
}

export async function runStudentFeedbackSubmitUnlock(opts) {
  const { currentSectionUid, ...rest } = opts;
  if (!railsStudentCaseUnlockContinue() || !currentSectionUid) return null;
  return continueToNextSection({
    ...rest,
    createContinueButtonIfNeeded: false,
    currentSectionUidOverride: currentSectionUid,
  });
}
